module.exports = __webpack_public_path__ + "img/deputados-estaduais.809d40a8.png";